export function getCacheUrlParamValue() {
  const minute = (new Date()).getMinutes()

  return minute % 5 < 2 ? 0 : 5;
}
